import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/dev/dev-alarm/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-dev/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-dev/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/dev/dev-alarm/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-dev/detail',
    method: 'get',
    params: { id }
  })
}
